import {Interval, IRange, Matm} from '../../classes/Matm';

declare let THREE: any;

export class DirectionalLight extends (THREE.DirectionalLight as { new(color, intensity): any; }) {

  private dirLightIntensity: IRange = {
    min: 0.75,
    max: 0.1
  };

  constructor() {
    super(0xffffff, 0);
    this.intensity = this.dirLightIntensity.min;
    this.name = 'gridDirLight';
    this.shadow.bias = 0;
    this.shadow.radius = 0.7;
    this.shadow.mapSize.set(2048, 2048);
    this.castShadow = true;
    const shadowCamera = this.shadow.camera;
    shadowCamera.left = -10000;
    shadowCamera.right = 10000;
    shadowCamera.bottom = -10000;
    shadowCamera.top = 10000;
    shadowCamera.far = 10000;
    shadowCamera.zoom = 25;
    shadowCamera.scale.set(7, 4, 2);
    shadowCamera.updateProjectionMatrix();
  }

  interpolateIntensity(input: Interval) {
    this.intensity = Matm.mapRange(input, this.dirLightIntensity);
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/env/DirectionalLight.ts